"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var SidebarItem_1 = __importDefault(require("./SidebarItem"));
var od_icon_1 = __importDefault(require("@tencent/od-icon"));
function SidebarList(_a) {
  var _b, _c;
  var _d = _a.open,
    open = _d === void 0 ? true : _d,
    data = _a.data,
    value = _a.value,
    onChange = _a.onChange,
    hide = _a.hide,
    label = _a.label,
    icon = _a.icon,
    iconClassName = _a.iconClassName,
    LinkComponent = _a.LinkComponent;
  var _e = __read((0, react_1.useState)((_b = data === null || data === void 0 ? void 0 : data.some(function (item) {
      return item.key === value;
    })) !== null && _b !== void 0 ? _b : false), 2),
    openSelect = _e[0],
    setOpenSelect = _e[1];
  var activeTitle = (0, react_1.useMemo)(function () {
    if (open && openSelect) return false;
    return data === null || data === void 0 ? void 0 : data.some(function (item) {
      return item.key === value;
    });
  }, [open, data, value, openSelect]);
  var currentHeight = (0, react_1.useMemo)(function () {
    var _a;
    var length = (_a = data === null || data === void 0 ? void 0 : data.filter(function (item) {
      return !item.hide;
    }).length) !== null && _a !== void 0 ? _a : 0;
    return length * (30 + 2) - 2;
  }, [data]);
  // 存在子节点激活，展开当前节点
  var hasActiveChild = (_c = data === null || data === void 0 ? void 0 : data.some(function (item) {
    return item.key === value;
  })) !== null && _c !== void 0 ? _c : false;
  (0, react_1.useEffect)(function () {
    hasActiveChild && setOpenSelect(hasActiveChild);
  }, [hasActiveChild]);
  if (hide) return null;
  return react_1["default"].createElement("div", {
    className: "odc-sidebar-list ".concat(open ? 'open' : 'no-open')
  }, react_1["default"].createElement("div", {
    className: "relative w-full",
    style: {
      width: '100%'
    },
    onClick: function onClick() {
      return setOpenSelect(function (i) {
        return !i;
      });
    }
  }, react_1["default"].createElement(SidebarItem_1["default"], {
    label: label,
    active: activeTitle,
    icon: icon,
    iconClassName: iconClassName,
    type: "first-level"
  }), react_1["default"].createElement(od_icon_1["default"], {
    className: "odc-sidebar-list-title-arrow",
    name: "down-medium-outlined",
    style: {
      transform: "rotate(".concat(openSelect ? '180deg' : '0', ")")
    }
  })), react_1["default"].createElement("div", {
    className: "odc-sidebar-list-ul ".concat(openSelect && open ? 'open-select' : 'no-open-select'),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    style: {
      '--ul-height': "".concat(currentHeight, "px")
    }
  }, data === null || data === void 0 ? void 0 : data.map(function (item, idx) {
    return react_1["default"].createElement(SidebarItem_1["default"], __assign({
      active: item.key === value,
      onClick: function onClick() {
        return onChange === null || onChange === void 0 ? void 0 : onChange(item);
      },
      type: "second-level",
      key: idx
    }, item, {
      LinkComponent: LinkComponent
    }));
  })));
}
exports["default"] = SidebarList;